namespace $ {

	export function $shm_projects_draft_note( id: string, next?: string ) {
		return $mol_state_local.value< string >( `$shm_projects_draft_note(${ id })`, next ) ?? ''
	}

}
